import { withTaskContext } from "@twilio/flex-ui";
import ParkChatButton from "./ParkChatButton";

export default withTaskContext(ParkChatButton);
